var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getDisplayMedia(options) {
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        return navigator.mediaDevices.getDisplayMedia({ preferCurrentTab: true });
    }
    const legacyNavigator = navigator;
    if (legacyNavigator.getDisplayMedia) {
        return legacyNavigator.getDisplayMedia(options);
    }
    if (legacyNavigator.webkitGetDisplayMedia) {
        return legacyNavigator.webkitGetDisplayMedia(options);
    }
    if (legacyNavigator.mozGetDisplayMedia) {
        return legacyNavigator.mozGetDisplayMedia(options);
    }
    throw new Error('getDisplayMedia is not defined');
}
function takeScreenshotStream() {
    return __awaiter(this, void 0, void 0, function* () {
        // see: https://developer.mozilla.org/en-US/docs/Web/API/Window/screen
        const width = window.screen.width * (window.devicePixelRatio || 1);
        const height = window.screen.height * (window.devicePixelRatio || 1);
        const errors = [];
        let stream;
        try {
            stream = yield getDisplayMedia({
                audio: false,
                video: {
                    frameRate: 1,
                    height,
                    width,
                },
            });
        }
        catch (ex) {
            errors.push(ex);
        }
        if (errors.length) {
            if (!stream) {
                throw errors[errors.length - 1];
            }
        }
        if (!stream) {
            throw new Error('Cannot take screenshot stream');
        }
        return stream;
    });
}
function takeScreenshotCanvas() {
    return __awaiter(this, void 0, void 0, function* () {
        const stream = yield takeScreenshotStream();
        const video = document.createElement('video');
        const result = yield new Promise((resolve) => {
            video.onloadedmetadata = () => {
                video.play();
                video.pause();
                const canvas = document.createElement('canvas');
                canvas.width = document.body.offsetWidth;
                canvas.height = document.body.offsetHeight;
                const context = canvas.getContext('2d');
                const diffX = 0;
                const diffY = 0;
                context.drawImage(video, -diffX, -diffY, document.body.offsetWidth, document.body.offsetHeight);
                resolve(canvas);
            };
            video.srcObject = stream;
        });
        stream.getTracks().forEach((track) => {
            track.stop();
        });
        if (result == null) {
            throw new Error('Cannot take canvas screenshot');
        }
        return result;
    });
}
function getPngBlob(canvas) {
    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error('Cannot create png blob'));
                return;
            }
            resolve(blob);
        }, 'image/png');
    });
}
export default function takeScreenshotJpegBlob() {
    return __awaiter(this, void 0, void 0, function* () {
        const canvas = yield takeScreenshotCanvas();
        return getPngBlob(canvas);
    });
}
